var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteConfirmation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_8799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1143 175.359C136.439 175.359 175.614 136.184 175.614 87.8594C175.614 39.5345 136.439 0.359375 88.1143 0.359375C39.7893 0.359375 0.614258 39.5345 0.614258 87.8594C0.614258 136.184 39.7893 175.359 88.1143 175.359Z",
    fill: "#FFB858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8618 87.8594L142.367 87.8594",
    stroke: "#E6570E",
    strokeWidth: 15,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_8799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 175,
    fill: "white",
    transform: "translate(0 0.359375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteConfirmation);
export default __webpack_public_path__ + "static/media/delete-confirmation.8feca937e6b66d0bcb998e2642ffe26d.svg";
export { ForwardRef as ReactComponent };